<template>
  <div>
    <NBar title="场地收益统计"/>
    <div class="top">
      <nut-scroller class="time-more">
        <div slot="list" @click="timeItemClick(index)"
             :style="{backgroundColor:timeSelect === item.label ? '#ffffff' : '#e9e9e9',
             border:timeSelect === item.label ? '1px solid #194fff' : '1px solid #e9e9e9',
             color:timeSelect === item.label ? '#194fff' : '#a1a5ab'}"
             class="time-item" v-for="(item ,index) in timeList" :key="index">{{ item.value }}
        </div>
      </nut-scroller>
      <nut-cell title="时间" :desc="date[0]+'至'+date[1]" :show-icon="true" @click.native="isCalendar = true"/>
      <nut-calendar :is-visible.sync="isCalendar" :default-value="date" type="range" :start-date="null"
                    :end-date="$util.formatDate.format(new Date(),'yyyy-MM-dd')"
                    @close="switchPickerClose('isCalendar')" @choose="setChooseValue">
      </nut-calendar>
      <nut-row>
        <nut-col :span="12">
          <div style="display: flex;align-items: center;">
            <div class="list list1" @click="switchMenu(1)">
              <span ref="title1">{{ addressList[0].name }}</span>
              <img :src="require('../../../resource/img/device/svg/arrow-down.svg')" style="width: 20px;height: 20px;">
            </div>
            <div style="height: 20px;width: 1px;background-color: #D4D4D4;"></div>
          </div>
          <nut-menu
            :is-animation="true"
            :isVisible="isVisible1"
            :list="addressList"
            type="simple"
            @close="switchMenu(1)"
            @choose="(item,index)=> chooseMenu(item,index,addressList,1)">
            <div slot="custom" class="menu-simple">
              <ul>
                <li v-for="(item, index) in addressList" :key="index" :class="item.selected ? 'selected' : ''"
                    :style="{color: item.selected ? '#1a87ff' : '#2d2d2d'}"
                    @click="chooseMenu(item, index,addressList,1)">
                  {{ item.name }}
                  <span v-if="item.selected"><nut-icon type="tick" color="#1a87ff"></nut-icon></span>
                </li>
              </ul>
            </div>
          </nut-menu>
        </nut-col>
        <nut-col :span="12">
          <div style="display: flex;align-items: center;">
            <div class="list list2" @click="switchMenu(2)">
              <span ref="title2">{{ deviceTypeList[0].name }}</span>
              <img :src="require('../../../resource/img/device/svg/arrow-down.svg')" style="width: 20px;height: 20px;">
            </div>
            <!--<div style="height: 20px;width: 1px;background-color: #D4D4D4;"></div>-->
          </div>
          <nut-menu
            :isVisible="isVisible2"
            :list="deviceTypeList"
            type="simple"
            @close="switchMenu(2)"
            @choose="(item,index)=> chooseMenu(item,index,deviceTypeList,2)">
            <div slot="custom" class="menu-simple">
              <ul>
                <li v-for="(item, index) in deviceTypeList" :key="index" :class="item.selected ? 'selected' : ''"
                    :style="{color: item.selected ? '#1a87ff' : '#2d2d2d'}"
                    @click="chooseMenu(item, index,deviceTypeList,2)">
                  {{ item.name }}
                  <span v-if="item.selected"><nut-icon type="tick" color="#1a87ff"></nut-icon></span>
                </li>
              </ul>
            </div>
          </nut-menu>
        </nut-col>
        <!--<nut-col :span="8">
          <div class="list list3">
            <span ref="title3" @click="switchMenu(3)">{{list3[0].text}}</span>
            <img :src="require('../../../resource/img/device/svg/arrow-down.svg')" style="width: 20px;height: 20px;">
          </div>
          <nut-menu
            :isVisible="isVisible3"
            :list="list3"
            type="simple"
            @close="switchMenu(3)"
            @choose="(item,index)=> chooseMenu(item,index,list3,3)">
          </nut-menu>
        </nut-col>-->
      </nut-row>
    </div>
    <div style="width: 100%;">
      <m-list style="height:calc(100vh - 249px);" ref="list" :data.sync="list" :page.sync="page" :limit.sync="limit"
              @loadlist="getData">
        <div slot="list">
          <div class="item-top" v-if="addressId === 0">
            <div
              style="height:60px; border-top-left-radius: 5px; border-top-right-radius: 5px; background-color: #194fff; display: flex;align-items: center;justify-content: center;color: white;">
              <span style="font-size: 18px;margin-right: 5px;">合计:</span>
              <nut-price
                :price="list.length > 0 ? list.map(item=>item.onlinePayMoney).reduce((prev,next)=>prev + next) : 0.00"
                :needSymbol="false" :thousands="true"/>
              <span style="font-size: 18px;margin-left: 5px;">元</span>
            </div>
            <div
              style="display: flex;align-items: center;justify-content: space-around;background-color: #196af5;color: white;height: 80px;border-bottom-left-radius: 5px; border-bottom-right-radius: 5px;">
              <div style="display: flex;flex-direction: column;align-items: center;">
                <span style="font-size: 16px;">在线支付</span>
                <nut-price
                  :price="list.length > 0 ? list.map(item=>item.onlinePayMoney).reduce((prev,next)=>prev + next) : 0.00"
                  :needSymbol="false" :thousands="true"/>
              </div>
              <!--<div style="height: 40px;background-color: #194fff;width: 1px;"></div>
              <div style="display: flex;flex-direction: column;align-items: center;">
                <span style="font-size: 16px;">补贴总额</span>
                <nut-price :price="0" :needSymbol="false" :thousands="true"/>
              </div>-->
            </div>
          </div>
          <div class="item-div" style="margin-top: 15px;" v-for="(item, index) in list" :key="index">
            <div class="title-div">
              <div style="display: flex;align-items: center;margin-left: 10px;">
                <span style="font-size: 16px;margin-right:5px;">{{ item.name }}</span>
                <div
                  style="background-color: #194fff;border-radius: 3px;padding: 2px 5px;color: white;font-size: 12px;">
                  {{ item.deviceCount || 0 }}台
                </div>
              </div>
              <div style="display: flex;align-items: center;margin-right: 10px;">
                <span style="font-size: 16px;margin-right: 5px;">合计:</span>
                <nut-price :price="item.onlinePayMoney || 0.00" :needSymbol="false" :thousands="true"/>
                <span style="font-size: 16px;margin-left: 5px;">元</span>
              </div>
            </div>
            <div class="content-div" @click="onlineItemClick(item)">
              <div style="width: 100%;margin-left: 10px;">
                <div
                  style="height: 40px; display: flex;align-items: center;width: 100%;justify-content: space-between;">
                  <span style="font-size: 14px;">在线支付</span>
                  <div>
                    <nut-price :price="item.onlinePayMoney || 0.00" :needSymbol="false" :thousands="true"/>
                    <span>元</span>
                  </div>
                </div>
                <!--<div
                  style="height: 40px; display: flex;align-items: center;width: 100%;justify-content: space-between;">
                  <span style="font-size: 14px;">在线支付</span>
                  <div>
                    <nut-price :price="1010" :needSymbol="false" :thousands="true"/>
                    <span>元</span>
                  </div>
                </div>-->
              </div>
              <img :src="require('../../../resource/img/device/arrow-right.png')" style="width: 30px;height: 30px;">
            </div>
            <nut-cell :show-icon="true" :to="`/device/SiteEarningsTrend?addressId=${addressId}`">
              <div slot="title"><span style="color: #1a87ff;">场地收益趋势</span></div>
            </nut-cell>
          </div>
        </div>
      </m-list>
    </div>
    <nut-tabbar ref="tab" @tab-switch="tabSwitch" :tabbar-list="tabList" :bottom="true"/>
  </div>
</template>

<script>
/**
 * 场地收益
 */
export default {
  name: 'SiteEarnings',
  data() {
    return {
      //当前选择时间索引
      timeSelect: 0,
      timeList: [
        {
          label: 0,
          value: '今天'
        }, {
          label: 1,
          value: '昨天'
        }, {
          label: 2,
          value: '本周'
        }, {
          label: 3,
          value: '本月'
        }, {
          label: 4,
          value: '半年'
        }],
      //时间选择器区间
      date: [],
      //是否显示时间选择器
      isCalendar: false,
      isVisible1: false,
      isVisible2: false,
      isVisible3: false,
      addressList: [
        {
          id: 0,
          name: '全部场地',
          selected: true
        }
      ],
      deviceTypeList: [
        {
          id: 0,
          name: '全部类型',
          selected: true
        }
      ],
      list3: [
        {
          id: 0,
          text: '分组标签',
          selected: true
        }
      ],
      addressId: 0,
      page: 1,
      limit: 20,
      list: [],
      tabList: [
        {
          'tabTitle': '场地收益',
          'curr': true,
          'icon': require ('../../../resource/img/device/svg/site_icon.svg'),
          'activeIcon': require ('../../../resource/img/device/svg/site_icon_active.svg')
        },
        {
          'tabTitle': '收益趋势',
          'curr': false,
          'icon': require ('../../../resource/img/device/svg/trends.svg'),
          'activeIcon': require ('../../../resource/img/device/svg/trends_active.svg')
        },
        {
          'tabTitle': '数据分析',
          'curr': false,
          'icon': require ('../../../resource/img/device/svg/data_analysis.svg'),
          'activeIcon': require ('../../../resource/img/device/svg/data_analysis_active.svg')
        }
      ]
    }
  },
  created() {
    this.date = [this.$util.formatDate.format (new Date (), 'yyyy-MM-dd'), this.$util.formatDate.format (new Date (), 'yyyy-MM-dd')]
  },
  activated() {
    this.$refs.tab.currIndex = 0
    this.getData ()
    this.findAddress ()
    this.findDeviceType ()
  },
  methods: {
    /**获取数据*/
    getData() {
      let data0 = this.date[0].replace (/-/g, '/')
      let data1 = this.date[1].replace (/-/g, '/')
      let time1 = new Date (data0 + ' 00:00:00')
      let time2 = new Date (data1 + ' 23:59:59')
      let data = {
        startTime: time1.getTime () / 1000,
        endTime: time2.getTime () / 1000,
        page: this.page,
        limit: this.limit
      }
      if (!this.$util.isArrOrNull (this.$api.merId)) {
        data.merId = this.$api.merId
      }
      if (!this.$util.isArrOrNull (this.$api.user.merIds)) {
        data.merIds = this.$api.user.merIds
      }
      if (this.addressId != 0) {
        data.addressId = this.addressId
      }
      this.$api.post ({
        url: '/device/api/device/address/earnings/list',
        data: data,
        loading: false
      }).then (res => {
        this.$refs.list.setRes (res)
      })
    },
    //查询设备类型列表
    findDeviceType() {
      this.$api.post ({
        url: '/device/api/device/device-type/find/list',
        loading: false
      }).then (res => {
        this.deviceTypeList = this.deviceTypeList.concat (res.data)
      })
    },
    //查询场地列表
    findAddress() {
      let data = {}
      if (!this.$util.isArrOrNull (this.$api.merId)) {
        data.merId = this.$api.merId
      }
      if (!this.$util.isArrOrNull (this.$api.user.merIds)) {
        data.merIds = this.$api.user.merIds
      }
      this.$api.post ({
        url: '/device/api/device/address/find',
        data: data,
        loading: false
      }).then (res => {
        this.addressList = res.data
        this.addressList.unshift ({
          id: 0,
          name: '全部场地',
          selected: true
        })
      })
    },
    //日期快捷选择
    timeItemClick(index) {
      this.timeSelect = index
      let time1 = new Date ()
      let time2 = new Date ()
      let nowDayOfWeek = time1.getDay () //今天本周的第几天
      let nowDay = time1.getDate () //当前日
      let nowMonth = time1.getMonth () //当前月
      let nowYear = time1.getFullYear () //当前年
      switch (index) {
        case 0://今天
          this.date[0] = this.$util.formatDate.format (time1, 'yyyy-MM-dd')
          this.date[1] = this.$util.formatDate.format (time2, 'yyyy-MM-dd')
          break
        case 1://昨天
          time1.setDate (time1.getDate () - 1)
          time2.setDate (time2.getDate () - 1)
          this.date[0] = this.$util.formatDate.format (time1, 'yyyy-MM-dd')
          this.date[1] = this.$util.formatDate.format (time2, 'yyyy-MM-dd')
          break
        case 2://本周
          let weekStartDate = new Date (nowYear, nowMonth, nowDay - nowDayOfWeek)
          //let weekEndDate = new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek))
          this.date[0] = this.$util.formatDate.format (weekStartDate, 'yyyy-MM-dd')
          this.date[1] = this.$util.formatDate.format (time2, 'yyyy-MM-dd')
          break
        case 3://本月
          let monthStartDate = new Date (nowYear, nowMonth, 1)
          /*let monthEndDate = new Date(nowYear, nowMonth + 1, 1)
          let days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24)
          monthEndDate = new Date(nowYear, nowMonth, days)*/
          this.date[0] = this.$util.formatDate.format (monthStartDate, 'yyyy-MM-dd')
          this.date[1] = this.$util.formatDate.format (time2, 'yyyy-MM-dd')
          break
        case 4://半年
          let monthTime = new Date (nowYear, nowMonth - 6, 1)
          this.date[0] = this.$util.formatDate.format (monthTime, 'yyyy-MM-dd')
          this.date[1] = this.$util.formatDate.format (time2, 'yyyy-MM-dd')
          break
      }
      this.getData ()
    },
    switchPickerClose(param) {
      this[`${param}`] = false
    },
    setChooseValue(param) {
      this.date = [...[param[0][3], param[1][3]]]
      this.isCalendar = false
      this.timeSelect = -1
      this.getData ()
    },
    switchMenu(num) {
      Array.from (document.querySelectorAll ('.list')).forEach (item => {
        item.style.zIndex = 0
      })
      if (!this['isVisible' + num]) {
        document.querySelector ('.list' + num).style.zIndex = 9999
      }
      this['isVisible' + num] = !this['isVisible' + num]
    },
    chooseMenu(item, index, list, num) {
      this.switchMenu (num)
      list.map ((value, key) => value.selected = false)
      this.$set (list[index], 'selected', true)
      this.$refs[`title${num}`].innerText = item.name
      this.addressId = list[index].id
      this.getData ()
    },
    /**
     * 场地收益详情列表
     * @param item
     */
    onlineItemClick(item) {
      this.$router.push ({
        path: '/device/SiteEarningsDetail',
        query: {
          addressId: item.id,
          name: item.name,
          deviceCount: item.deviceCount,
          onlinePayMoney: item.onlinePayMoney || 0.00,
          startTime: this.date[0],
          endTime: this.date[1]
        }
      })
    },
    tabSwitch: function (item, index) {
      switch (index) {
        case 0:
          this.getData ()
          this.findAddress ()
          //this.$router.push('/device/SiteEarnings')
          break
        case 1:
          this.$router.replace ('/device/SiteEarningsTrend')
          break
        case 2:
          this.$router.replace ('/device/DataAnalysis')
          break
      }
    }
  }
}
</script>

<style scoped>
>>> .curr {
  color: #1a87ff;
}

>>> .nut-calendar-control .nut-calendar-cancel-btn, >>> .nut-calendar-control .nut-calendar-confirm-btn {
  color: #1a87ff;
}

>>> .nut-calendar-control .nut-calendar-week span:first-child, >>> .nut-calendar-control .nut-calendar-week span:last-child {
  color: #1a87ff;
}

>>> .nut-calendar-months .nut-calendar-month-con .nut-calendar-month-day-active {
  background-color: #1a87ff;
}

>>> .nut-calendar-months .nut-calendar-month-con .nut-calendar-month-day-choose {
  background-color: #abd1ff;
}

.top {
  display: flex;
  flex-direction: column;
  background-color: white;
}

.top .time-more {
  margin: 10px 0;
}

.top .time-more .time-item {
  font-size: 14px;
  background-color: #e9e9e9;
  border: 1px solid #e9e9e9;
  color: #a1a5ab;
  border-radius: 5px;
  width: 50px;
  text-align: center;
  padding: 6px 0;
  margin-left: 10px;
}

.list {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  justify-content: center;
  min-height: 40px;
  width: 99%;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  text-decoration: none;
  -webkit-tap-highlight-color: transparent;
  outline: none;
  background-color: #fff;
}

.item-top {
  margin: 10px;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
}

.item-div {
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: white;
}

.item-div .title-div {
  border-top: 0.5px solid #d3d3d3;
  background-color: #d9e6fd;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
}

.item-div .content-div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/device/home/SiteEarnings.vue